export { retrieveAndSetPageLoadTrace } from './retrieve-and-set-page-load-trace';
